import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CustomerBillData } from '../../services/customer-bill.service';

@Component({
  selector: 'app-display-pr-cmpa',
  templateUrl: './display-pr-cmpa.component.html',
  styleUrls: ['./display-pr-cmpa.component.css']
})
export class DisplayPrCmpaComponent implements OnInit, OnDestroy {

  prCmpa: any;
  characs: any[] = [];
  prices: any[] = [];
  sid: string;

  prCmpaForm: FormGroup;

  subs: Subscription[] = [];

  constructor(
    private prCmpaService: ProductCmpaService,
    private customerBillData: CustomerBillData,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.subs.push(this.prCmpaService.getPrCmpa(this.sid).subscribe(([data]) => {
      this.prCmpa = data;
      this.prCmpaForm.patchValue(data);
      
      this.prCmpaForm.get('classnId').setValue(data.data.name);
      if(data.unitRef){
        let subUnit = this.prCmpaService.getUnitDoc(data.unitRef.path).subscribe(unit => {
          subUnit.unsubscribe();
          this.prCmpaForm.get('unitName').setValue(unit.name);
        });
      }

      data.characs.map(charac => {
        const unitRef = charac.unitId.path;
        const unit = this.prCmpaService.getUnitDoc(unitRef);
        let subUnit = unit.subscribe(dataUnit => {
          charac.nameUnit = dataUnit.name;
          charac.unitId = charac.unitId.id;
          subUnit.unsubscribe();
        });
      });
      data.prices.map(price => {
        const supplierRef = price.supplierId.path;
        const supplier = this.prCmpaService.getSupplierDoc(supplierRef);
        let subSupplier = supplier.subscribe(dataSup => {
          price.supplierName = dataSup.name;
          price.supplierId = price.supplierId.id;
          subSupplier.unsubscribe();
        })
      });
      this.characs=data.characs;
      this.prices=data.prices;
    })
    );
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }


  createForm() {
    this.prCmpaForm = this.fb.group({
      name: '',
      description: '',
      activeComponent: '',
      code: '',
      classnId: '',
      unitName: '',
      reorderQuantity: '',
      lastPriceUsed: 0,
    });
  }

}
